module.exports = __webpack_public_path__ + "static/img/20010 (1).dea2b38.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20010 (1).webp
// module id = yhsE
// module chunks = 14